export default __webpack_public_path__ + "static/media/Allyson-McCabe.0a4ec57d.jpg";